import React from 'react'
import { useSelector } from 'react-redux'

import UplifterSvg from '../svgs/uplifter'
import styles from '../component-styles/forgot-password.module.scss'
import Message from './login-message'
import Button from './button'

export default function Result(): React.ReactElement {
  const { success } = useSelector(
    (state: any): any => state.support.forgotPassword,
  )

  if (success) {
    return (
      <>
        <UplifterSvg link className={styles.svg} />
        <h2>A smarter way to track campaigns</h2>
        <div className={styles.divider} />
        <Message message="Password reset email has been sent. Please check your inbox." />
        <div className={styles.divider} />
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
          href="https://support.uplifter.ai/hc/en-us/articles/360018765078-I-can-t-login-to-Uplifter"
        >
          Need help logging in?
        </a>
      </>
    )
  }

  return (
    <>
      <UplifterSvg link className={styles.svg} />
      <h2>A smarter way to track campaigns</h2>
      <div className={styles.divider} />
      <Message message="We are currently experiencing some issues. Please [try again](/login) or contact us by emailing [support@uplifter.ai](mailto:support@uplifter.ai)." />
      <div className={styles.divider} />
      <h2>Don't have an account?</h2>
      <Button type="flatGrey" to="/create-account">
        Sign up here
      </Button>
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
        href="https://support.uplifter.ai/hc/en-us/articles/360018765078-I-can-t-login-to-Uplifter"
      >
        Need help logging in?
      </a>
    </>
  )
}
